/**
 * Demo pharmacie — the single tenant a BETA user "owns".
 *
 * Realistic Algerian pharmacy profile used across the chrome (sidebar,
 * settings, receipt headers, branding).
 */
export function buildPharmacie() {
  return {
    id: "beta-pharm-001",
    nom: "Pharmacie Démo PHARMAKON",
    raison_sociale: "Pharmacie Démo PHARMAKON SARL",
    nif: "099816029000035",
    nis: "099816029000035",
    rc: "16/00-9876543B25",
    ai: "16-0987654-25",
    adresse: "12, Rue des Frères Boudjelthia",
    ville: "Alger",
    wilaya: "Alger",
    code_postal: "16000",
    telephone: "+213 21 99 88 77",
    email: "demo@pharmakon.dz",
    site_web: "https://pharmakon.dz",
    logo_url: null,
    enseigne: "PHARMAKON",
    horaires: "Lun-Sam 08h00-20h00 · Dim 09h00-13h00",
    pharmacien_responsable: "Dr. Amine Belkacem",
    n_agrement_moh: "DZ-MOH-2018-7842",
    n_ordre_pharmacien: "PH-16-04219",
    licence: {
      id: "beta-licence-001",
      statut: "ACTIVE",
      plan: "PRO",
      valid_until: nextYearISO(),
      modules: ["CORE", "CHIFA", "AIDE_DECISION", "EFACTURE", "MULTI_CAISSE"],
      seats_total: 8,
      seats_used: 4,
    },
    branding: {
      primary_color: "#16a34a",
      accent_color: "#059669",
    },
    parametres: {
      ticket_footer: "Merci de votre visite — À bientôt sur PHARMAKON",
      auto_print: true,
      langue: "fr",
      devise: "DZD",
      tva_default_pct: 19,
    },
    role_counts: {
      PROPRIETAIRE: 1,
      MANAGER: 1,
      CAISSIER: 2,
    },
    created_at: "2024-01-15T09:00:00.000Z",
  };
}

function nextYearISO() {
  const d = new Date();
  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString();
}
